import type { Company } from '../../domain/company';
import { useDispatchTrackEventWithLocation } from '../../services/tracking/hooks/useDispatchTrackEventWithLocation';
export const useCompanyNameTracking = (company: Company | undefined) => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleTracking = (action: string, eventName: string, data: string | undefined) => {
    dispatchTrackEventWithLocation('company data', action, `${eventName}/${data || ''}`);
  };

  const handleTrackWebsiteClick = () => handleTracking('click website link', 'open website', company?.domain);

  const handleTrackLinkedinLinkClick = () =>
    handleTracking('click linkedin link', 'open linkedin', company?.linkedinId);

  const handleTrackCompanyOverviewClick = () =>
    handleTracking('click on company name', 'open company overview', company?.name);

  return {
    handleTrackWebsiteClick,
    handleTrackLinkedinLinkClick,
    handleTrackCompanyOverviewClick,
  };
};
